import { defineMessages } from 'react-intl'

export default defineMessages({
  baseCurrencyLabel: {
    id: 'LegalEntityReview.baseCurrencyLabel',
    defaultMessage: 'Base currency',
  },
  externalIdLabel: {
    id: 'LegalEntityReview.externalIdLabel',
    defaultMessage: 'External ID',
  },
  countryLabel: {
    id: 'LegalEntityReview.countryLabel',
    defaultMessage: 'Country',
  },
  inboxEmailAddressLabel: {
    id: 'LegalEntityReview.inboxEmailAddressLabel',
    defaultMessage: 'Invoice inbox address',
  },
  inboxEmailAddressPermanentWarning: {
    id: 'LegalEntityReview.inboxEmailAddressPermanentWarning',
    defaultMessage:
      "This inbox address is permanent. You can't change it after you create the entity.",
  },
  emptyValue: {
    id: 'LegalEntityReview.emptyValue',
    defaultMessage: 'None added',
  },
  editButton: {
    id: 'LegalEntityReview.editButton',
    defaultMessage: 'Edit',
  },
  confirmButton: {
    id: 'LegalEntityReview.confirmButton',
    defaultMessage: 'Confirm',
  },
})
